/* =============================================================================
 * A build that has moved on
 * -----------------------------------------------------------------------------
 * Lives in core rather than beside the router because two layers need the same
 * answer and must not each have their own version of it: lazyRoute decides
 * whether to reload the page, and errorMessage decides what to tell the person
 * and how to file it.

 * They disagreed. errorMessage matched "failed to fetch" and called it a
 * dropped connection, so a stale build told somebody to check their internet
 * and reached the platform's queue labelled "offline" — advice that cannot
 * work, against a diagnosis that sends the operator looking at the wrong
 * thing.
 * ========================================================================== */

/**
 * The browser's several ways of saying "that file is not there".
 *
 * Matched on message rather than type because every engine words it
 * differently and none of them throw a distinguishable error class. Anything
 * unrecognised is left alone — a module that throws while *evaluating* is a
 * real bug in this app, and reloading the page would hide it behind a flicker.
 */
export function isMissingChunk(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return (
    /failed to fetch dynamically imported module/i.test(message)
    || /error loading dynamically imported module/i.test(message)
    || /importing a module script failed/i.test(message)
    || /'text\/html' is not a valid javascript mime type/i.test(message)
  );
}
